import {Initialize} from "./libs/Initialize";

// initialize the app
Initialize.do();